import React from "react";

const TONE = {
    development: "border-sky-300/40 bg-sky-300/10 text-sky-200",
    staging: "border-amber-300/50 bg-amber-300/10 text-amber-200",
    production: "border-emerald-300/40 bg-emerald-300/10 text-emerald-300",
};

export function EnvBadge({ environment, market, testId }) {
    if (!environment) return null;
    return (
        <span data-testid={testId} title={`SiteCentric ${market || ""} ${environment}`.trim()}
            className={`px-1.5 py-0.5 rounded-sm border text-[10px] font-mono uppercase tracking-wider ${TONE[environment] || TONE.development}`}>
            {market ? `${market} · ` : ""}{environment}
        </span>
    );
}

const STATUS = {
    ok: "border-emerald-300/40 bg-emerald-300/10 text-emerald-300",
    broken: "border-red-400/50 bg-red-400/10 text-red-300",
    untested: "border-white/15 bg-white/5 text-white/55",
};

export function ConnStatus({ status, testId }) {
    return <span data-testid={testId} className={`px-1.5 py-0.5 rounded-sm border text-[10px] font-mono ${STATUS[status] || STATUS.untested}`}>{status || "untested"}</span>;
}
